<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加测试数据</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="添加测试数据"
      width="800px"
      @close="closeDialog"
    >
      <el-form :model="vals" ref="form" :rules="rules" label-width="150px">
        <el-form-item label="币种选择" prop="coinType">
          <el-select v-model="vals.coinType">
            <el-option
              v-for="item in coinTypeList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户ID：" prop="userId">
          <el-input v-model="vals.userId"></el-input>
        </el-form-item>
        <el-form-item label="存入金额" prop="amount">
          <el-input-number v-model="vals.amount" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="设置存入时间：" prop="testTime">
          <el-date-picker
            v-model="vals.testTime"
            type="date"
            placeholder="选择日期"
            format="yyyy 年 MM 月 dd 日"
            value-format="timestamp"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSaves()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import MutipleInput from '../mutipleInput';

export default {
  name: 'cornucopiaCreate',
  data() {
    return {
      dialogVisible: false,
      vals: {
        coinType: '',
        userId: '',
        amount: '',
        testTime: ''
      },
      rules: {
        coinType: {
          required: true,
          message: '请填写'
        },
        userId: {
          required: true,
          message: '请填写'
        },
        amount: {
          required: true,
          message: '请填写'
        },
        testTime: {
          required: true,
          message: '请填写'
        }
      }
    };
  },
  components: {},
  computed: {
    ...mapState('cornucopia', ['coinTypeList'])
  },
  methods: {
    ...mapActions('cornucopia', ['createTest']),
    closeDialog() {
      this.dialogVisible = false;
      this.detail = {};
      this.$refs['form'].resetFields();
    },
    handleSaves() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      this.createTest(this.vals).then(() => {
        this.$message({
          message: '添加成功！',
          type: 'success'
        });
        this.dialogVisible = false;
        this.$emit('refresh');
      });
    }
  }
};
</script>

<style lang="less">
.editor {
  height: 500px;
}
</style>
